"use client"
import { useContext } from "react"
import { UserContext } from "../../context/UserContext"
import Link, { type LinkProps } from "../Link/Link"

export function MyAccountLink(props: Omit<LinkProps, 'href'>) {
  const { children, ...otherProps } = props;
  const { isLogged } = useContext(UserContext)
  const href: string = isLogged ? '/customer/account' : '/customer/login'

  return (
    <Link href={href} {...otherProps}>
      {children} 
    </Link>
  );
}
